/* EBIKO store notice (vacation banner). Reads the Hub-controlled setting and shows
 * a site-wide top bar + a notice above the cart/drawer checkout button. Stays
 * invisible unless the Hub toggle is on. Resilient: 5s timeout, silent fail. */
(function () {
  var HUB = 'https://ebiko-order-tracker.onrender.com';
  var BAR_DISMISS_KEY = 'ebk_store_notice_dismissed';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function injectCss() {
    if (document.getElementById('ebk-sn-css')) return;
    var s = document.createElement('style');
    s.id = 'ebk-sn-css';
    s.textContent =
      '.ebk-sn-bar{background:#153850;color:#fff;font-size:13.5px;line-height:1.4;padding:11px 16px;display:flex;align-items:center;gap:10px;justify-content:center;text-align:center;}' +
      '.ebk-sn-bar a{color:#F6B93B;text-decoration:underline;}' +
      '.ebk-sn-bar .ebk-sn-x{margin-left:14px;cursor:pointer;opacity:.7;font-size:18px;line-height:1;background:none;border:0;color:#fff;padding:0 4px;}' +
      '.ebk-sn-bar .ebk-sn-x:hover{opacity:1;}' +
      '.ebk-sn-cart{background:#FAEEDA;border:1px solid #EF9F27;border-radius:8px;padding:14px 16px;margin:0 0 16px;color:#633806;font-size:13.5px;line-height:1.55;}' +
      '.ebk-sn-cart strong{display:block;color:#412402;font-size:14.5px;margin-bottom:4px;font-weight:600;}';
    document.head.appendChild(s);
  }

  function renderBar(data) {
    try { if (sessionStorage.getItem(BAR_DISMISS_KEY) === '1') return; } catch (e) {}
    if (document.querySelector('.ebk-sn-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'ebk-sn-bar';
    var txt = document.createElement('span');
    txt.innerHTML = '<strong style="font-weight:600;">' + esc(data.title) + '.</strong> Orders ship as soon as we’re back — you can still order now.';
    bar.appendChild(txt);
    if (data.dismissible) {
      var x = document.createElement('button');
      x.className = 'ebk-sn-x'; x.setAttribute('aria-label', 'Dismiss'); x.innerHTML = '×';
      x.onclick = function () { try { sessionStorage.setItem(BAR_DISMISS_KEY, '1'); } catch (e) {} bar.remove(); };
      bar.appendChild(x);
    }
    document.body.insertBefore(bar, document.body.firstChild);
  }

  function cartBox(data) {
    var d = document.createElement('div');
    d.className = 'ebk-sn-cart ebk-sn-cart-box';
    d.innerHTML = '<strong>' + esc(data.title) + '</strong>' + esc(data.message);
    return d;
  }

  function renderCart(data) {
    if (location.pathname.indexOf('/cart') !== 0) return;
    if (document.querySelector('[data-section-type="cart"] .ebk-sn-cart-box, .cart-wrapper .ebk-sn-cart-box')) return;
    var anchor = document.querySelector('[data-section-type="cart"] .container, .cart-wrapper, main .container');
    if (anchor) anchor.insertBefore(cartBox(data), anchor.firstChild);
  }

  function renderDrawer(data) {
    // Inject above the drawer/mini-cart checkout button whenever the drawer is in the DOM.
    var btn = document.querySelector('.mini-cart [name="checkout"], .mini-cart [href*="/checkout"], .drawer [name="checkout"], .drawer [href*="/checkout"]');
    if (!btn) return;
    var holder = btn.closest('.mini-cart__recap, .mini-cart__footer, .drawer__footer') || btn.parentElement;
    if (!holder || holder.querySelector('.ebk-sn-cart-box')) return;
    holder.insertBefore(cartBox(data), holder.firstChild);
  }

  function render(data) {
    if (!data || !data.enabled || !data.title) return;
    injectCss();
    renderBar(data);
    renderCart(data);
    renderDrawer(data);
    // The cart drawer mounts/opens later — re-check on DOM changes (debounced).
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; renderDrawer(data); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function load() {
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, 5000);
    fetch(HUB + '/api/storefront/vacation-banner', { signal: ctrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) { clearTimeout(t); render(data); })
      .catch(function () { clearTimeout(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
